import { render, staticRenderFns } from "./PaymentCollectBox.vue?vue&type=template&id=4538da1f&scoped=true"
import script from "./PaymentCollectBox.vue?vue&type=script&lang=js"
export * from "./PaymentCollectBox.vue?vue&type=script&lang=js"
import style0 from "./PaymentCollectBox.vue?vue&type=style&index=0&id=4538da1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4538da1f",
  null
  
)

export default component.exports